module.exports = __webpack_public_path__ + "img/VigilantMedicalTransparentLogo.334d71a4.png";